import React from 'react';
import isEqual from 'lodash.isequal';

/**
 * Similar to useEffect, but a callback is only called when the dependencies change, not on every render.
 */
function useChangedEffect(
  effect: React.EffectCallback,
  deps: React.DependencyList,
) {
  const prevDeps = React.useRef<React.DependencyList | null>(null);

  React.useEffect(() => {
    if (!isEqual(deps, prevDeps.current)) {
      prevDeps.current = deps; // Update deps before calling effect
      effect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

export default useChangedEffect;
